import { useAppSelector } from '../Redux/hooks';
import { Mode, OfferInfoType } from '../App';
import styles from './Status.module.scss';
import { useOutletContext } from 'react-router';


type Props = {
    mode: Mode
};

type Context = {
    offerInfo: OfferInfoType
};


export const Status: React.FC<Props> = ({ mode }) => {

    const { offerInfo } = useOutletContext<Context>();
    const { offerId, client, manager, createdAt } = offerInfo;

    const isLogined = useAppSelector((state) => state.authorization.value);

    var date = new Date(createdAt * 1000);
    var months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    var year = date.getFullYear();
    var month = months[date.getMonth()];
    var day = date.getDate();

    return (
        <div className={`${styles.wrapper} ${(isLogined || offerId) ? styles.withStatus : ''}`} id="StatusWrapper">

            <div className={styles.status} >

                {mode === Mode.CALCULATOR && <p>Режим калькулятора</p>}
                {mode === Mode.THE_OFFER &&
                    <>
                        {offerId && isLogined
                            && <>
                                <p>КП от <b>{day} {month} {year}</b>. Менеджер
                                    {manager
                                        ? <>: <b>{manager}</b> </>
                                        : " не указан"
                                    }
                                </p>
                                <p>Клиент
                                    {client
                                        ? <>: <b>{client}</b> </>
                                        : " не указан"
                                    }
                                </p>
                            </>}
                        {offerId && !isLogined
                            &&
                            <h4>Коммерческое предложение</h4>
                            // <button onClick={() => alert('Для оплаты, пожалуйста, свяжитесь с менеджером')}>
                            //     Оплатить
                            // </button>
                        }
                        {!offerId && <p>Несохраненное КП</p>}
                    </>
                }

            </div >
        </div >
    )
}

export default Status
